import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgPlug(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.693 6.864a1.063 1.063 0 0 1 0 1.503l-3.757 3.756 2.254 2.254a1.063 1.063 0 0 1-1.502 1.503l-1.503 1.503a7.438 7.438 0 0 1-9.712.696l-3.06 3.06a1.063 1.063 0 0 1-1.503-1.502l3.06-3.06a7.438 7.438 0 0 1 .696-9.712L8.17 5.361a1.063 1.063 0 0 1 1.502-1.503l2.254 2.254 3.757-3.756a1.063 1.063 0 0 1 1.502 1.502L13.43 7.616l3.005 3.005 3.756-3.757a1.063 1.063 0 0 1 1.503 0ZM8.17 8.367a5.313 5.313 0 0 0 7.513 7.513l1.502-1.503-7.513-7.513L8.17 8.367Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgPlug)
